import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{t \"error.page_not_found\"}}\n",{ moduleName: "uplisting-frontend/pods/not-found/template.hbs" })